import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { Short01 } from 'module/ui/components/styles';
import styled from 'styled-components';

const Icon = styled(CenterAlignedBox)`
  color: var(--icon-interactive);
`;
const Text = styled.div``;

const LabelElement = styled(CenterAlignedBox)<{ $mandatory?: boolean }>`
  ${Short01};
  font-weight: var(--font-weight-semi-bold);

  &[data-required='true']::after {
    content: '*';
    color: #dc2626;
    font-weight: bold;
  }
`;

type Label = typeof LabelElement & {
  Text: typeof Text;
  Icon: typeof Icon;
};
export const Label: Label = LabelElement as any;
Label.Text = Text;
Label.Icon = Icon;
